import React, { Component } from "react";
import { FontSizeButtonGroup } from "../../../components/settings/slideshow/FontSizeButtonGroup";

class FontSizeContainer extends Component {
  handleFontSizeChange = (event, value) => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    if (this.props.selectedSlideshow === "0") {
      tournamentRef.update({ slideshowFontSize: value });
    } else {
      let diaDoc = tournamentRef
        .collection("slideshows")
        .doc(this.props.selectedSlideshow);
      diaDoc.update({ slideshowFontSize: value });
    }
  };

  render() {
    let fontSize =
      (this.props.slideshowsByKey[this.props.selectedSlideshow] || {})
        .slideshowFontSize || "1";
    if (this.props.selectedSlideshow === "0") {
      fontSize = this.props.tournament.slideshowFontSize || "1";
    }
    if (
      !this.props.tournament.slideshowFontSize &&
      (this.props.tournament.vrsn < 4 ||
        this.props.tournament.vrsn === undefined)
    ) {
      fontSize = "0";
    }
    return (
      <FontSizeButtonGroup
        fontSize={fontSize}
        handleFontSizeChange={this.handleFontSizeChange}
      />
    );
  }
}

export default FontSizeContainer;
